var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('header-bar',{attrs:{"id":"header-bar"}}),_c('router-view',{attrs:{"id":"router-view"}}),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }